import styled from 'styled-components/macro'

export const SelectProfilesMenu = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: ${({ theme }) =>
    `${theme.v3.margins.content.spacing.small} ${theme.v3.margins.content.spacing.medium}`};
`
